// src/lib/supabase.js
console.log('supabase.js is loading');
import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;
console.log('URL:', url, 'KEY:', key ? key.slice(0, 20) + '...' : 'MISSING');

if (!url || !key) {
  console.error(
    'Missing Supabase env vars. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env.local'
  );
}

export const supabase = createClient(url, key);